export function ensureAppAdmin(user: { user_role: string }): void {
  if (user.user_role !== 'app-admin') {
    throw new Error('This panel is for platform admins only');
  }
}
